

import {deleteAndCreate,createFile,deleteFile,getFile,listDataFile,updateFile} from '@/zsm-api-new/file.js'
const state = {

}

const mutations = {

}

const actions = {
  
  // 替换素材信息
  deleteAndCreate({ commit }, info) {
    // let {id,title} =info
    return new Promise((resolve, reject) => {
      deleteAndCreate(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 修改素材信息
  updateFile({ commit }, info) {
    // let {id,title} =info
    return new Promise((resolve, reject) => {
      updateFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看素材列表
  listDataFile({ commit }, info) {
    return new Promise((resolve, reject) => {
      listDataFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 查看单个素材
  getFile({ commit }, info) {
    return new Promise((resolve, reject) => {
      getFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增媒体
  deleteFile({ commit }, id) {
    return new Promise((resolve, reject) => {
      deleteFile(id).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 新增媒体
  createFile({ commit }, info) {
    return new Promise((resolve, reject) => {
      createFile(info).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
